/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdatePasswordInput = {
    clientMutationId?: string | null;
    newPass: string;
    oldPass: string;
};
export type UpdatePasswordDialogMutationVariables = {
    input: infoUpdatePasswordInput;
};
export type UpdatePasswordDialogMutationResponse = {
    readonly infoUpdatePassword: {
        readonly clientMutationId: string | null;
    } | null;
};
export type UpdatePasswordDialogMutation = {
    readonly response: UpdatePasswordDialogMutationResponse;
    readonly variables: UpdatePasswordDialogMutationVariables;
};



/*
mutation UpdatePasswordDialogMutation(
  $input: infoUpdatePasswordInput!
) {
  infoUpdatePassword(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoUpdatePasswordPayload",
    "kind": "LinkedField",
    "name": "infoUpdatePassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePasswordDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePasswordDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1a397053ad779835139c4a88eed0bdd6",
    "id": null,
    "metadata": {},
    "name": "UpdatePasswordDialogMutation",
    "operationKind": "mutation",
    "text": "mutation UpdatePasswordDialogMutation(\n  $input: infoUpdatePasswordInput!\n) {\n  infoUpdatePassword(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '830f1d72ead642f87a489f6d8eda8a11';
export default node;
